const events = [
  {
    id: 1,
    title: "Summer Music Festival 2025",
    category: "Music",
    description: "Join us for an unforgettable evening under the stars featuring top indie and electronic artists. Experience world-class performances, stunning light shows, and an atmosphere that will leave you wanting more. This year's lineup includes internationally acclaimed DJs and live bands performing across multiple stages.",
    date: "2025-07-15",
    time: "18:00",
    location: "Central Park Amphitheater, New York",
    venue: "Central Park Amphitheater",
    city: "New York",
    price: 89.99,
    image: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?w=800&q=80",
    capacity: 5000,
    organizer: "Live Nation Events",
    tags: ["Music", "Festival", "Outdoor", "Live Performance"]
  },
  {
    id: 2,
    title: "Tech Innovation Summit",
    category: "Technology",
    description: "Discover the future of technology at this exclusive summit featuring keynotes from industry leaders, interactive workshops, and networking opportunities. Learn about AI, blockchain, cloud computing, and emerging technologies shaping tomorrow. Perfect for developers, entrepreneurs, and tech enthusiasts.",
    date: "2025-08-22",
    time: "09:00",
    location: "Silicon Valley Convention Center, San Francisco",
    venue: "Silicon Valley Convention Center",
    city: "San Francisco",
    price: 299.00,
    image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=800&q=80",
    capacity: 2000,
    organizer: "TechCorp International",
    tags: ["Technology", "Conference", "Networking", "Innovation"]
  },
  {
    id: 3,
    title: "Championship Basketball Finals",
    category: "Sports",
    description: "Witness the ultimate showdown as the top two teams battle for the championship title. Experience the excitement of professional basketball at its finest with thrilling plays, incredible athleticism, and an electrifying atmosphere. Don't miss this historic sporting event!",
    date: "2025-06-10",
    time: "19:30",
    location: "Madison Square Garden, New York",
    venue: "Madison Square Garden",
    city: "New York",
    price: 150.00,
    image: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=800&q=80",
    capacity: 20000,
    organizer: "NBA Events",
    tags: ["Sports", "Basketball", "Championship", "Live"]
  },
  {
    id: 4,
    title: "Modern Art Exhibition",
    category: "Art",
    description: "Immerse yourself in contemporary art from renowned artists worldwide. This exclusive exhibition features paintings, sculptures, digital art, and interactive installations. Explore diverse artistic expressions and meet the artists behind these stunning works. Includes guided tours and artist talks.",
    date: "2025-09-05",
    time: "10:00",
    location: "Museum of Modern Art, Los Angeles",
    venue: "Museum of Modern Art",
    city: "Los Angeles",
    price: 45.00,
    image: "https://images.unsplash.com/photo-1531243269054-5ebf6f34081e?w=800&q=80",
    capacity: 500,
    organizer: "MOMA Exhibitions",
    tags: ["Art", "Exhibition", "Culture", "Museum"]
  },
  {
    id: 5,
    title: "International Food & Wine Festival",
    category: "Food",
    description: "Savor culinary delights from around the world at this gourmet food festival. Experience tastings from Michelin-star chefs, cooking demonstrations, wine pairings, and artisanal food vendors. A paradise for food lovers featuring international cuisines and premium beverages.",
    date: "2025-10-12",
    time: "12:00",
    location: "Harbor Front Plaza, Miami",
    venue: "Harbor Front Plaza",
    city: "Miami",
    price: 75.00,
    image: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80",
    capacity: 3000,
    organizer: "Gourmet Events Co.",
    tags: ["Food", "Wine", "Festival", "Culinary"]
  },
  {
    id: 6,
    title: "Stand-Up Comedy Night",
    category: "Entertainment",
    description: "Laugh until your sides hurt with performances from the hottest comedians in the business. An evening of non-stop entertainment featuring hilarious stand-up routines, improv, and special guest appearances. Perfect for a night out with friends!",
    date: "2025-07-28",
    time: "20:00",
    location: "Comedy Club Central, Chicago",
    venue: "Comedy Club Central",
    city: "Chicago",
    price: 35.00,
    image: "https://images.unsplash.com/photo-1585699324551-f6c309eedeca?w=800&q=80",
    capacity: 300,
    organizer: "Laugh Factory Productions",
    tags: ["Comedy", "Entertainment", "Stand-up", "Live Show"]
  },
  {
    id: 7,
    title: "Marathon Run 2025",
    category: "Sports",
    description: "Challenge yourself in this annual city marathon attracting runners from around the globe. Whether you're a seasoned marathoner or first-timer, this scenic route through downtown offers an incredible experience. Includes pre-race expo, professional timing, and finisher medals.",
    date: "2025-11-03",
    time: "07:00",
    location: "Downtown City Center, Boston",
    venue: "Downtown City Center",
    city: "Boston",
    price: 65.00,
    image: "https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?w=800&q=80",
    capacity: 10000,
    organizer: "City Marathon Association",
    tags: ["Sports", "Running", "Marathon", "Fitness"]
  },
  {
    id: 8,
    title: "Jazz Night Under the Stars",
    category: "Music",
    description: "Experience smooth jazz in an intimate outdoor setting. Featuring acclaimed jazz musicians performing classic and contemporary pieces. Enjoy a relaxing evening with great music, food trucks, and a beautiful ambiance under the night sky.",
    date: "2025-08-08",
    time: "19:00",
    location: "Riverside Gardens, Portland",
    venue: "Riverside Gardens",
    city: "Portland",
    price: 55.00,
    image: "https://images.unsplash.com/photo-1415201364774-f6f0bb35f28f?w=800&q=80",
    capacity: 800,
    organizer: "Jazz Society of Portland",
    tags: ["Music", "Jazz", "Outdoor", "Live Performance"]
  },
  {
    id: 9,
    title: "Startup Pitch Competition",
    category: "Business",
    description: "Watch innovative startups pitch their groundbreaking ideas to top investors. Network with entrepreneurs, investors, and industry leaders. Witness the next big thing in tech, health, fintech, and more. Includes networking reception and award ceremony.",
    date: "2025-09-18",
    time: "14:00",
    location: "Innovation Hub, Austin",
    venue: "Innovation Hub",
    city: "Austin",
    price: 120.00,
    image: "https://images.unsplash.com/photo-1560439513-74b037a25d84?w=800&q=80",
    capacity: 500,
    organizer: "Startup Accelerator Network",
    tags: ["Business", "Startups", "Networking", "Innovation"]
  },
  {
    id: 10,
    title: "Classical Symphony Orchestra",
    category: "Music",
    description: "An enchanting evening of classical masterpieces performed by the renowned city symphony orchestra. Experience the beauty of Beethoven, Mozart, and Tchaikovsky in a historic concert hall. Dress code: formal attire.",
    date: "2025-12-15",
    time: "19:30",
    location: "Grand Concert Hall, Philadelphia",
    venue: "Grand Concert Hall",
    city: "Philadelphia",
    price: 95.00,
    image: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=800&q=80",
    capacity: 1200,
    organizer: "Philadelphia Orchestra",
    tags: ["Music", "Classical", "Orchestra", "Concert"]
  },
  {
    id: 11,
    title: "Yoga & Wellness Retreat",
    category: "Wellness",
    description: "Rejuvenate your mind, body, and soul at this weekend wellness retreat. Includes yoga sessions, meditation workshops, healthy gourmet meals, spa treatments, and mindfulness activities. Perfect for anyone seeking relaxation and self-care.",
    date: "2025-07-19",
    time: "08:00",
    location: "Serenity Resort, Sedona",
    venue: "Serenity Resort",
    city: "Sedona",
    price: 350.00,
    image: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=800&q=80",
    capacity: 100,
    organizer: "Wellness Retreats Inc.",
    tags: ["Wellness", "Yoga", "Meditation", "Retreat"]
  },
  {
    id: 12,
    title: "Electronic Dance Music Festival",
    category: "Music",
    description: "The biggest EDM festival of the year featuring world-famous DJs and producers. Dance the night away with incredible sound systems, stunning visuals, and an unforgettable party atmosphere. Multiple stages with diverse electronic music genres.",
    date: "2025-08-30",
    time: "17:00",
    location: "Desert Arena, Las Vegas",
    venue: "Desert Arena",
    city: "Las Vegas",
    price: 199.00,
    image: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?w=800&q=80",
    capacity: 15000,
    organizer: "EDM Global Events",
    tags: ["Music", "EDM", "Festival", "Dance"]
  }
];

export default events;
